module.exports = __webpack_public_path__ + "static/media/account-info.93e23fff.svg";